/**
 * Minimal analytics helpers ported from the car-finance-frontend shared
 * analytics module.  Used by SmsLander to push tracking events to
 * Google Tag Manager via `window.dataLayer`.
 *
 * Both helpers are safe no-ops when `window.dataLayer` is absent.
 */

export function trackPageView(pageName, additionalData = {}) {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: pageName,
      pageName,
      timestamp: new Date().toISOString(),
      ...additionalData,
    });
  }
}

export function trackCustomEvent(eventName, eventData = {}) {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      timestamp: new Date().toISOString(),
      ...eventData,
    });
  }
}
